  import { ChatMessage } from "../types/Chatbot/Chat";
  
  // copy to clipboard function
  export const copyToClipboard = (chatMessage: ChatMessage) => {
    const formattedText = `
    Question: ${chatMessage.question}
    Summary: ${chatMessage.summary}
    Explanation: ${chatMessage.explanation}
    Sources: ${chatMessage.sources.join(", ")}
    `.trim();

    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Use Clipboard API if available
      navigator.clipboard
        .writeText(formattedText)
        .then(() => {
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    } else {
      // Fallback: Use hidden textarea
      const textArea = document.createElement("textarea");
      textArea.value = formattedText;
      // Prevent visual appearance
      textArea.style.position = "fixed";
      textArea.style.top = "-1000px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Fallback: Failed to copy text: ", err);
      } finally {
        document.body.removeChild(textArea);
      }
    }
  };

  export const downloadAsCsv = (chatMessage: ChatMessage) => {
    // Format CSV data
    const csvContent = [
      ["Question", chatMessage.question],
      ["Summary", chatMessage.summary],
      ["Explanation", chatMessage.explanation],
      ["Sources", chatMessage.sources.join(", ")],
    ]
      .map((row) => row.map((value) => `"${value}"`).join(","))
      .join("\n");

    // Create CSV Blob
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Generate a download link
    const currentDate = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const fileName = `${chatMessage.question.replace(/[^a-z0-9]/gi, "_")}_${currentDate}.csv`;
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;

    // Trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };